<script lang="ts" setup>
type Props = {
  label: string;
  color: "red" | "orange" | "yellow" | "blue" | "green" | "gray";
};

const props = withDefaults(defineProps<Props>(), {
  color: "gray",
});
</script>

<template>
  <span
    role="presentation"
    :class="`is-${props.color}`"
    class="tag w-fit text-primary-500 text-xs font-semibold rounded py-[6px] px-4 bg-primary-100"
  >
    {{ props.label }}
  </span>
</template>

<style lang="scss" scoped>
.tag {
  &.is-green {
    @apply text-primary-500 bg-primary-100 #{!important};
  }

  &.is-red {
    @apply text-error-400 bg-error-50 #{!important};
  }

  &.is-orange {
    @apply text-orange bg-orange-50 #{!important};
  }

  &.is-yellow {
    @apply text-yellow bg-yellow-50 #{!important};
  }

  &.is-blue {
    @apply text-blue bg-blue-50 #{!important};
  }

  &.is-gray {
    @apply text-gray-400 bg-gray-200 dark:bg-white/5 #{!important};
  }
}
</style>
